import { useUIStateStore } from "@/store/uiStateStore";

import useSiteConfigAuth from "../api/sanity/queries/getSiteConfigWithCode";
import useGetColours from "../helpers/getColours";

function SmallButton(props) {
  const { children, onClick, disabled } = props;
  const { data: siteConfig } = useSiteConfigAuth();
  const { highlightColour } = useGetColours(siteConfig);
  const isTunecore = useUIStateStore(state => state.isTunecore);

  return (
    <>
      <button
        disabled={disabled}
        type="button"
        style={
          isTunecore
            ? {
                background: disabled
                  ? "linear-gradient(to bottom right, rgba(0, 239, 134, 0.5), rgba(0, 142, 185, 0.5))"
                  : "linear-gradient(to bottom right, #00ef86, #008eb9)",
                borderRadius: "50px",
                padding: "10px 16px",
              }
            : {
                backgroundColor: highlightColour,
                opacity: disabled ? "0.5" : "1",
              }
        }
        className="px-4 py-2 mb-1 text-xs font-bold text-white uppercase transition-all duration-150 ease-linear rounded-lg shadow outline-none disabled:pointer-events-none active:bg-old-sentric-dark-gray hover:scale-105 hover:shadow-md disabled:shadow-none focus:outline-none"
        onClick={onClick}
      >
        {children}
      </button>
    </>
  );
}

export default SmallButton;
